import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import Goodbtn from "../assets/good_btn_none.png";
import Normalbtn from "../assets/normal_btn_none.png";
import Badbtn from "../assets/bad_btn_none.png";

import ttsAudio from "../assets/sound/tts_05.mp3"; // mp3 경로 import
import ttsAudio_en from "../assets/sound/en/5.mp3";
import ttsAudio_jp from "../assets/sound/jp/5.mp3";
import ttsAudio_cn from "../assets/sound/cn/5.mp3";
import ttsAudio_mn from "../assets/sound/mn/6.mp3";

const About2_2 = () => {
    const { t,i18n } = useTranslation();
    const navigate = useNavigate();
    const { name } = useParams();
    const { sex } = useParams();
    const { birth } = useParams();
    const { feel } = useParams();

    const [height, setHeight] = useState(""); // cm
    const [weight, setWeight] = useState(""); // kg
    const [activeField, setActiveField] = useState("height"); // 'height' | 'weight'


    const [tody,SetToday]=useState();

    const audioRef = useRef(null);
    const inputRef = useRef(null);

    const clickNext= item => {
        if (!height || !weight) {
            swal(t("키와 몸무게를 모두 입력해주세요"));
            return;
        }

        // 간단 검증(원하시면 범위 체크도 넣어드릴게요)
        navigate(`/about3/${name}/${sex}/${birth}/${feel}/${height}/${weight}`);
    };
    
    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    var lng=i18n.language;

    return (
        <main className="main-container">
            {lng == "mn" && <audio ref={audioRef} src={ttsAudio_mn} autoPlay />}

            <div className="input-area">
                <div className="step_area">STEP 5</div>
                <div className="title_area">
                    <h1 className="num_title">(5/5)</h1>
                    <h2 className="title">{t("키와 몸무게를 입력하세요")}</h2>
                </div>

                <div className="input_section" style={{ background: "#fff", paddingTop: 0 }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                        {/* 키 */}
                        <div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <input
                                    type="number"
                                    inputMode="numeric"
                                    className="text_nor md"
                                    autoComplete="off"
                                    value={height}
                                    style={{ marginBottom: 50 }}
                                    placeholder={t("170")}
                                    onChange={e => {
                                        // 키는 정수만(원하시면 소수 허용도 가능)
                                        const v = e.target.value.replace(/[^\d]/g, "");
                                        setHeight(v);
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === "Enter") clickNext();
                                    }}
                                />
                                <span style={{ minWidth: "28px", opacity: 0.7 }}>cm</span>
                            </div>
                        </div>

                        {/* 몸무게 */}
                        <div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <input
                                    ref={inputRef}
                                    type="text"
                                    inputMode="decimal"
                                    className="text_nor md"
                                    autoComplete="off"
                                    value={weight}
                                    placeholder={t("65")}
                                    onChange={e => {
                                        // 숫자 + 소수점 1개만 허용, 소수 1자리까지만
                                        let v = e.target.value.replace(/[^\d.]/g, "");
                                        const parts = v.split(".");
                                        if (parts.length > 2) v = parts[0] + "." + parts.slice(1).join("");
                                        const [a, b] = v.split(".");
                                        if (b?.length > 1) v = a + "." + b.slice(0, 1);
                                        setWeight(v);
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === "Enter") clickNext();
                                    }}
                                />
                                <span style={{ minWidth: "28px", opacity: 0.7 }}>kg</span>
                            </div>
                        </div>
                    </div>

                    <div className="start-btn-area">
                        <button className={`Next ${weight ? "active" : "disabled"}`} onClick={() => clickNext()}>
                            {t("확인")}
                        </button>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default About2_2;
